<table mat-table [dataSource]="dataSource" *ngIf="loadTemplate">

  <!--  Columnas dinamicas de datos  -->
  <ng-container [matColumnDef]="column.title" *ngFor="let column of config.columns">
    <th mat-header-cell *matHeaderCellDef>{{ column.title }}</th>
    <ng-container *ngIf="column.transform !== undefined; else elseBlock">
      <td mat-cell *matCellDef="let element">{{column.transform(element)}}</td>
    </ng-container>
    <ng-template #elseBlock>
      <td mat-cell *matCellDef="let element">{{ element | extractData:column.dataKey }}</td>
    </ng-template>
  </ng-container>

  <!--  Columna para las acciones  -->
  <ng-container matColumnDef="acciones">
    <th mat-header-cell *matHeaderCellDef>
      Acciones
    </th>
    <td mat-cell *matCellDef="let row">
      <ng-container *ngFor="let action of config.actions">
        <a *ngIf="action.show | evalFn:row" (click)="onAction(action.accionId, row)">
          <mat-icon aria-hidden="false">{{action.icon}}</mat-icon>
        </a>
      </ng-container>
    </td>
  </ng-container>

    <!--  Columna para las acciones  -->
    <ng-container matColumnDef="chips">
        <th mat-header-cell *matHeaderCellDef>
            Estado
        </th>
        <td mat-cell *matCellDef="let row">
            <div *ngFor="let chip of config.chips">
                <span *ngIf="chip.show | evalFn:row" [ngStyle]="{'background-color': '#' + chip.color}"
                      class="chip">{{chip.title}}</span>
            </div>
        </td>
    </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
